import { render, staticRenderFns } from "./DeletePaymentDialog.vue?vue&type=template&id=8c1066fa&"
import script from "./DeletePaymentDialog.vue?vue&type=script&lang=ts&"
export * from "./DeletePaymentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports